<template>
  <a-form ref='ruleForm' :model='form' :rules="rules">
    <a-form-item label="礼品" :wrapper-col="{span:20}" required name="gift_content">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-input v-model:value="form.gift_content" readonly></a-input>
        </a-col>
        <a-col :span="12">
          <a-button type="primary" @click="visible=true">
            选择
          </a-button>
        </a-col>
      </a-row>
    </a-form-item>
    <a-form-item label="领奖方式" required v-if="gift_gift_type==1">
      <a-radio-group v-model:value="form.gift_receive_award_type" @change="doneHandle">
        <a-radio :value="1">总部快递发奖</a-radio>
        <!-- <a-radio :value="2">
          到店核销
          <a-tooltip>
            <template #title>到店核销的订单有效期在订单设置中配置</template>
            <exclamation-circle-filled class="fz-16 s_c376 m-l-5" />
          </a-tooltip>
        </a-radio> -->
        
      </a-radio-group>
      <!-- <div v-if="form.gift_is_store">
        <a-radio-group v-model:value="form.gift_is_appoint_store">
          <a-radio :value="0">全部门店</a-radio>
          <a-radio :value="1">指定门店</a-radio>
        </a-radio-group>
        <div class="s_flex" v-if="form.gift_is_appoint_store==1">
          <div class="m-r-10">
            选择门店:
          </div>
          <div>
            <a-button type="primary" @click="storeVisible=true">
              选择门店
            </a-button>
            <div @click="chooseStoreVisible=true" v-if="storeList.length">
              <a href="javascript:;">查看已选门店</a>
            </div>
          </div>
        </div>
      </div> -->
    </a-form-item>
    <a-form-item label="有效时间" required name="gift_effective_day" v-show="form.gift_receive_award_type==1&&gift_gift_type==1">
      <a-input-number :precision="0" v-model:value="form.gift_effective_day" :min="1" @blur="doneHandle"></a-input-number> 天内领取有效（中奖时间将作为生效开始时间）
    </a-form-item>
    <!-- <a-form-item label="运费设置" required name="gift_express_id" v-if="form.gift_is_express==1">
      <a-select :style="{width:'200px'}" placeholder="请选择" v-model:value="form.gift_express_id">
        <a-select-option v-for='(item,index) in freightList' :key="index" :value="item.id">{{item.name}}</a-select-option>
      </a-select>
    </a-form-item> -->
  </a-form>
  <a-modal  :keyboard="false" v-model:visible="visible" centered style="width:700px" :width='1200' :footer="null" destroyOnClose>
    <a-tabs>
      <a-tab-pane :key="1" tab="自有礼品">
        <selectGiftLibrary v-on:select="selectGift" :isReal="isReal" />
      </a-tab-pane>
      <a-tab-pane :key="2" tab="产品库">
        <selectGood v-on:select="goodSelect" />
      </a-tab-pane>
    </a-tabs>
  </a-modal>
  <!-- 选择门店 -->
  <a-modal  :keyboard="false" v-model:visible="storeVisible" centered style="width:700px" :width='1000' :footer="null" destroyOnClose>
    <selectStore v-on:select="storeSelect" :selectList='storeList' :checkout='true'></selectStore>
  </a-modal>
  <!-- 查看已选门店 -->
  <a-modal  :keyboard="false" v-model:visible="chooseStoreVisible" title="已选门店" centered style="width:700px" :width='1000' destroyOnClose>
    <a-table :pagination='false' bordered :columns='columns' :data-source='storeList'>
      <template v-slot:action="{ index }">
        <a-button type="primary" @click='del(index)'>删除</a-button>
      </template>
    </a-table>
  </a-modal>
</template>
<script>
import { ExclamationCircleFilled } from "@ant-design/icons-vue";
import store from "@/store";
import { onMounted, reactive, ref, toRefs } from "vue";
import { getDeliveryList } from "@/api/order";
import { iscode } from "@/utils/app";
import { message } from "ant-design-vue";
import { getStoreList } from "@/api/store";
const columns = [
  {
    title: "商品信息",
    dataIndex: "product",
    slots: { customRender: "product" },
    width: 300,
  },
  {
    title: "市场价",
    dataIndex: "market_price",
    key: "market_price",
  },
  {
    title: "库存",
    dataIndex: "stock_num",
    key: "stock_num",
    customRender: ({ record }) => {
      return record.stock || record.stock_num;
    },
  },
  {
    title: "操作",
    dataIndex: "action",
    slots: { customRender: "action" },
  },
];
const rules = {
  gift_content: [
    {
      required: true,
      message: "请选择礼品",
    },
  ],
  gift_receive_award_type: [
    {
      type: "array",
      required: true,
      message: "请选择领奖方式",
      trigger: "change",
    },
  ],
  gift_effective_day: [
    {
      type: "number",
      required: true,
      message: "请输入礼品有效期",
    },
  ],
  gift_express_id: [
    {
      required: true,
      message: "请选择运费",
    },
  ],
};
export default {
  // components: { ExclamationCircleFilled },
  props: {
    giftDetail: Object,
    isReal:{
      type:Boolean
    }
  },
  setup(props,{emit}) {
    const ruleForm = ref();
    const form = ref({
      gift_receive_award_type: 1, //领奖方式 1快递 2自提
      gift_store_array: [], //门店数据
      gift_is_appoint_store: 0, //0全部门店 指定门店
      gift_effective_day: 7, //礼品有效期
      is_guider: 1, //导购核销 这期没有  0 不开启 1 开启
      gift_content: "", //礼品描述
      gift_id: "", //礼品ID
      gift_express_id: "", //运费ID
      gift_type: "", //1礼品库 2产品库
    });
    const state = reactive({
      gift_gift_type:1,//礼品的礼品类型
      visible: false,
      freightList: [],
      info: store.state.user.info,
      gift_content: "",
    });
    const doneHandle=()=>{
            console.log(form.value)
            if(form.value.gift_receive_award_type==1){
              form.value.gift_is_express=1
              form.value.gift_is_store=0
            }else{
              form.value.gift_is_express=0
              form.value.gift_is_store=1
            }
        emit('giftDone',form.value);
    }
    const selectGift = (data) => {
      state.visible = false;
      form.value.gift_content = data.gift_name;
      form.value.gift_id = data.id;
      form.value.gift_type = 1;
      state.gift_gift_type = data.gift_type;
      doneHandle()
      // id
    };
    const goodSelect = (data) => {
      state.visible = false;
      form.value.gift_content = data.product_name;
      form.value.gift_id = data.id;
      form.value.gift_type = 2;
      doneHandle()
      // id
    };
  
    const submit = () => {
            form.value.gift_is_express = form.value.gift_is_express
          ? 1
          : 0;
        form.value.gift_is_store =form.value.gift_is_store
          ? 1
          : 0;
      return new Promise((resolve, reject) => {
        ruleForm.value
          .validate()
          .then(async (res) => {
            if (
              form.value.gift_is_appoint_store == 1 &&
              !form.value.gift_store_array.length
            ) {
              message.error("请选择指定门店");
              return;
            }
            resolve(form.value);
          })
          .catch((error) => {
            reject(false);
          });
      });
    };
    // 获取运费模板
    const getFreight = async () => {
      let res = await getDeliveryList({ page: 1, limit: 99 }).then(
        (res) => res.data
      );
      if (iscode(res)) {
        state.freightList = res.data.data;
      } else {
        message.error(res.msg);
      }
    };

    // 选择门店
    const storeVisible = ref(false);
    const storeList = ref([]);
    const storeSelect = (data) => {
      storeList.value = data;
      form.value.gift_store_array = [];
      data.map((v) => {
        form.value.gift_store_array.push({
          id: v.id,
          store_code: v.store_code,
          store_name: v.store_name,
        });
      });
      storeVisible.value = false;
    };
    // 查看已选门店
    const chooseStoreVisible = ref(false);
    const columns = [
      {
        title: "门店编号",
        dataIndex: "store_code",
        key: "store_code",
      },
      {
        title: "门店名称",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        slots: { customRender: "action" },
      },
    ];
    onMounted(() => {
      if (props.giftDetail) {
        console.log(props.giftDetail);
        form.value = props.giftDetail;
        state.gift_gift_type = props.giftDetail.is_entity ? 1 : 2;
        
        if (form.value.gift_store_array&&form.value.gift_store_array.length) {
          // 查询门店列表
            storeList.value=form.value.gift_store_array
        }
        if(form.value.gift_is_express){
          form.value.gift_receive_award_type=1
        }else if(form.value.gift_is_store) {
          form.value.gift_receive_award_type=2
        }else{
          form.value.gift_receive_award_type=0 //0是未选择的值
        }
      emit('giftDone',form.value);
      }
      getFreight();
    });
    return {
      ...toRefs(state),
      goodSelect,
      selectGift,
      ruleForm,
      form,
      rules,
      storeList,
      storeSelect,
      storeVisible,
      columns,
      submit,
      chooseStoreVisible,
      doneHandle
    };
  },
};
</script>